import signupSlice from './signupSlice';

export { signupSelector, signupOperations } from './signupSlice';
export const signupReducer = signupSlice.reducer;
export const signupActions = signupSlice.actions;
